import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import mapPortfolioChartDataFromApi from 'rtkQuery/sharespro/mapper/modules/portfolio/mapPortfolioChartDataFromApi';
import { mapPeOrderListItemFromApi } from 'rtkQuery/sharespro/mapper/modules/pe/orders/mapPeOrderListFromApi';
import { mapPeCompanyOrderListItemFromApi } from 'rtkQuery/sharespro/mapper/modules/pe/companyOrders/mapPeCompanyOrderListFromApi';
import { mapOrderListItemFromApi } from 'rtkQuery/sharespro/mapper/modules/orders/mapOrderListFromApi';
import {
  mapPortfolioAccountsDataFromApi,
  mapPortfolioCurrencyBalanceItemFromApi,
} from 'rtkQuery/sharespro/mapper/modules/portfolio/mapPortfolioDataFromApi';
import { HomePageData } from 'model/modules/home/homePageData';
import mapStrategyListFromApi from 'rtkQuery/sharespro/mapper/modules/strategies/mapStrategyListFromApi';
import mapOnlineDocumentFromApi from 'rtkQuery/sharespro/mapper/modules/onlineDocument/mapOnlineDocumentFromApi';
import mapServiceListFromApi from 'rtkQuery/sharespro/mapper/modules/services/mapServiceListFromApi';

const mapHomeDataFromApi = (
  resp: SharesproApiResponse<ApiFetchHomeResponseData>
): HomePageData => {
  return {
    chart: mapPortfolioChartDataFromApi(resp.data.chart),
    accounts: mapPortfolioAccountsDataFromApi(resp.data.accounts),
    unsignedDocuments: resp.data.unsigned_documents.map(
      mapOnlineDocumentFromApi
    ),
    peInvestorsOrders: resp.data.investor_pe_orders.map(
      mapPeOrderListItemFromApi
    ),
    peSharesproOrders: resp.data.company_pe_orders.map(
      mapPeCompanyOrderListItemFromApi
    ),
    orders: resp.data.orders.map(mapOrderListItemFromApi),
    isProfileFilled: resp.data.is_profile_filled,
    currencyBalances: resp.data.currencies.map(
      mapPortfolioCurrencyBalanceItemFromApi
    ),
    services: mapServiceListFromApi(resp.data.services),
    strategies: mapStrategyListFromApi(resp.data.strategies),
    isShowGeneralSurvey: resp.data.is_show_npc,
    total_compensation_amount: resp.data.total_compensation_amount,
    total_compensation_progress: resp.data.total_compensation_progress,
  };
};

export default mapHomeDataFromApi;
